import * as React from 'react';
import { useState, useEffect, useRef } from 'react';
import { Col } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { Typography, Dropdown, Space, Button } from "antd";
import { FaCloudDownloadAlt, FaEllipsisV } from 'react-icons/fa';
import Link from 'antd/es/typography/Link';
import dayjs from 'dayjs';
import { useDispatch, useSelector } from 'react-redux';
import { setLoader } from '../../../Slices/loaderSlice';
import { AntdButton } from '../../../blueplanitUtils/InputField';
import { CustomGridTable } from '../../../blueplanitUtils/CustomGridTable';
import { createAttachmentThunk, deleteAttachmentThunk, getAllAttachmentsByIDThunk, multipleAttachmentsThunk, updateAttachmentThunk } from '../../../Slices/Thunk/attachmentsThunks';
import { S3ACCESSURL } from '../../../databucket';

export default function AttachemntsHistory() {

  const dispatch = useDispatch();
  const { id } = useParams()
  const fileInputRef = useRef(null);
  const fileInputRefSingle = useRef(null);
  const assignToUsers = useSelector((state) => state.employee.AllEmployees);
  const loginUser = useSelector((state) => state?.loginUserInfo?.loginUserDetails);
  const userid = loginUser?.id;

  const [attachmentStatus, setAttachmentStatus] = useState(false)
  const [attachmentsHistory, setAttachmentsHistory] = useState([])
  const [modifiedAttachmentsHistory, setModifiedAttachmentsHistory] = useState([])

  useEffect(() => {
    dispatch(getAllAttachmentsByIDThunk({ emailId: id }))
      .unwrap()
      .then(({ raw, flattened }) => {
        setAttachmentsHistory(raw);
        setModifiedAttachmentsHistory(flattened);
      });
  }, [attachmentStatus]);

  const handleSingleAttachment = (event) => {
    const file = event.target.files[0];
    dispatch(setLoader(true));

    dispatch(createAttachmentThunk({ file, emailId: id, userId: userid }))
      .unwrap()
      .then(() => setAttachmentStatus(prev => !prev))
      .finally(() => dispatch(setLoader(false)));
  };

  const handleMultipleAttachment = (event, index) => {
    const files = Array.from(event.target.files);
    dispatch(setLoader(true));

    dispatch(multipleAttachmentsThunk({
      files,
      userId: userid,
      emailId: id
    }))
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        setAttachmentStatus((prev) => !prev);
      })
      .catch((err) => {
        console.error(err);
        dispatch(setLoader(false));
      });
  };

  const handleupadteAttachment = (event) => {
    return event.target.files[0];
  }
  const updateHandler = async (attachmentId) => {
    const selectedFile = await new Promise(resolve => {
      const input = document.getElementById('updateAttachmentInput');
      input.addEventListener('change', (e) => resolve(e.target.files[0]), { once: true });
      input.click();
    });

    dispatch(setLoader(true));
    dispatch(updateAttachmentThunk({ file: selectedFile, attachmentId, userId: userid }))
      .unwrap()
      .then(() => setAttachmentStatus(prev => !prev))
      .finally(() => dispatch(setLoader(false)));
  };

  const deleteHandler = (attachmentId) => {
    dispatch(setLoader(true));
    dispatch(deleteAttachmentThunk({ id: attachmentId, userId: userid }))
      .unwrap()
      .then(() => setAttachmentStatus(prev => !prev))
      .finally(() => dispatch(setLoader(false)));
  };


  const handleDownload = (fileUrl, fileName) => {

    fetch(S3ACCESSURL+fileUrl)
      .then(response => response.blob())
      .then(blob => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const a = document.createElement('a');
        a.href = url;
        a.download = fileName; // Set desired file name
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(error => console.error('Error downloading file:', error));
  };

  const getStatus = (status, addDate, updateDate) => {
    let resultData = ""
    if (status) {
      if (addDate === updateDate) {
        resultData = "Created"
      } else {
        resultData = "Deleted"
      }
    } else {
      resultData = "Updated"
    }
    return resultData;
  }

  const getUserName = (userid) => {
    const user = assignToUsers?.find(userdetails => userdetails?.id === userid);
    if (user) {
      return user.firstname + " " + user.lastname;
    }
    return 'anonymous';
  }

return (
  <>
    <input
      type="file"
      id="updateAttachmentInput"
      onChange={handleupadteAttachment}
      style={{ display: "none" }}
    />

    {/* ---------------- ATTACHMENTS ---------------- */}
    <div className="attachments-wrapper">
      <div className="attachments-card">
        <div className="attachments-inner">

          {/* Header */}
          <div className="attachments-header">
            <Typography.Title level={5} style={{ margin: 0, padding: 0 }}>
              Attachments
            </Typography.Title>

            <div className="attachments-icons">

              {/* Single File */}
              <div className="icon-blue">
                <input
                  type="file"
                  ref={fileInputRefSingle}
                  onChange={handleSingleAttachment}
                  style={{ display: "none" }}
                />
                <i
                  className="fa-solid fa-file icon-file"
                  onClick={() => fileInputRefSingle.current?.click()}
                />
              </div>

              {/* Multiple Files */}
              <div className="icon-blue">
                <input
                  type="file"
                  multiple
                  ref={fileInputRef}
                  onChange={handleMultipleAttachment}
                  style={{ display: "none" }}
                />
                <i
                  className="fa-regular fa-folder-open icon-folder"
                  onClick={() => fileInputRef.current?.click()}
                />
              </div>

            </div>
          </div>

          {/* Scroll container */}
          <div className="attachments-scroll">
            <CustomGridTable
              Id={`attachments-table-${id}`}
              columns={[
                {
                  title: "Document Name",
                  key: "filename",
                  render: (_, record) => (
                    <a
                      href={S3ACCESSURL + record.data}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {record.filename}
                    </a>
                  ),
                },
                {
                  title: "Created Date",
                  key: "addDate",
                  dataIndex: "addDate",
                  render: (val) =>
                    dayjs(parseInt(val)).format(
                      "DD/MM/YYYY hh:mm:ss A"
                    ),
                },
                {
                  title: "Creator",
                  key: "creator",
                  render: (_, record) => getUserName(record.userId),
                },
                {
                  title: "Actions",
                  key: "actions",
                  render: (_, record) => (
                    <AntdButton
                      variant="solid"
                      color="primary"
                      size="small"
                      onClick={() =>
                        handleDownload(
                          S3ACCESSURL + record.data,
                          record.filename
                        )
                      }
                      icon={<FaCloudDownloadAlt />}
                    />
                  ),
                },
                {
                  title: "Options",
                  key: "options",
                  render: (_, record) => {
                    const items = [
                      {
                        key: "replace",
                        label: "Replace",
                        onClick: () => updateHandler(record.id),
                      },
                      {
                        key: "delete",
                        label: "Delete",
                        onClick: () => deleteHandler(record.id),
                        danger: true,
                      },
                    ];

                    return (
                      <Dropdown menu={{ items }} trigger={["click"]}>
                        <Button 
                          type="text" 
                          icon={<FaEllipsisV size={16} />}
                          style={{ cursor: "pointer" }}
                        />
                      </Dropdown>
                    );
                  },
                },
              ]}
              dataSource={[...attachmentsHistory]
                .filter((r) => r.status)
                .sort(
                  (a, b) =>
                    parseInt(b.addDate) - parseInt(a.addDate)
                )}
              rowKey={(record) => record.id}
              pagination={false}
              size="small"
            />
          </div>

        </div>
      </div>
    </div>

    {/* ---------------- ATTACHMENT HISTORY ---------------- */}
    <div className="history-wrapper">
      <div className="history-card">
        <div className="history-inner">

          <div className="history-header">
            <Typography.Title level={5} style={{ margin: 0, padding: 0 }}>
              Attachment History
            </Typography.Title>
          </div>

          <div className="history-scroll">
            <CustomGridTable
              Id={`attachment-history-${id}`}
              columns={[
                {
                  title: "S.No",
                  key: "sno",
                  render: (_text, _record, index) => index + 1,
                },
                {
                  title: "Document Name",
                  key: "filename",
                  render: (_, record) => (
                    <a
                      href={record.data}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {record.filename}
                    </a>
                  ),
                },
                {
                  title: "Add Date",
                  key: "addDate",
                  dataIndex: "addDate",
                  render: (val) =>
                    dayjs(parseInt(val)).format(
                      "DD/MM/YYYY hh:mm:ss A"
                    ),
                },
                {
                  title: "Updated Date",
                  key: "updateDate",
                  dataIndex: "updateDate",
                  render: (val) =>
                    dayjs(parseInt(val)).format(
                      "DD/MM/YYYY hh:mm:ss A"
                    ),
                },
                {
                  title: "User Name",
                  key: "user",
                  render: (_, record) => getUserName(record.userId),
                },
                {
                  title: "Actions",
                  key: "actions",
                  render: (_, record) =>
                    getStatus(
                      record.status,
                      record.addDate,
                      record.updateDate
                    ),
                },
              ]}
              dataSource={[...modifiedAttachmentsHistory].sort(
                (a, b) =>
                  parseInt(b.addDate) - parseInt(a.addDate)
              )}
              rowKey={(r) => r.id}
              pagination={false}
              size="small"
            />
          </div>

        </div>
      </div>
    </div>
  </>
);
}